import { Switch } from 'sonata-react-components';

import { GroupingModalsProvider } from '../../grouping/components';
import { useMultiFlightMap } from '../../MultiFlightMap.context';
import { ListsStyled } from './Lists.styled';
import LocationList from './Locations/LocationsList';
import ScreensList from './Screens/ScreensList';
import VenuesList from './Venues/VenuesList';

type Props = {
  mapId: string;
};

export function Lists({ mapId }: Props) {
  const { list } = useMultiFlightMap();

  return (
    <ListsStyled className="lists">
      <div className="lists__container">
        <GroupingModalsProvider>
          <Switch>
            <Switch.Case condition={list === 'locations'}>
              <LocationList mapId={mapId} />
            </Switch.Case>
            <Switch.Case condition={list === 'screens'}>
              <ScreensList mapId={mapId} />
            </Switch.Case>
            <Switch.Case condition={list === 'venues'}>
              <VenuesList mapId={mapId} />
            </Switch.Case>
          </Switch>
        </GroupingModalsProvider>
      </div>
    </ListsStyled>
  );
}
